export function stripMsisdn(msisdn=""){

    if(msisdn.startsWith("+")) {
        msisdn = msisdn.slice(1);
    }
    else if(msisdn.startsWith("0")) {
        msisdn = "27" + msisdn.slice(1);
    }

    return msisdn;
}

const MsisdnSearchStripper = {
    stripMsisdn
};

export default MsisdnSearchStripper;